// extracted by mini-css-extract-plugin
module.exports =  {"select":"select--taasX","option":"option--pxFFe","icon":"icon--_Siqn"};